import React from 'react';
import { CalculatorInternational } from '/react4xp/parts/price-calculator-international/PriceCalculatorInternational'; 

export default (props) => <CalculatorInternational {...props} />
